<div class="relative">
  <router-outlet />
  <!-- the job app inside the Umweltmesse's anymatch app wears the same fair logo and attribution -->
  <img
    [class]="position"
    [ngStyle.gt-xs]="{ maxWidth: '120px', height: 'auto', maxHeight: '158px' }"
    [ngStyle.xs]="{ maxWidth: '64px', height: 'auto', maxHeight: '80px' }"
    [src]="(isDark$ | async) ? watermarkDarkSrc : watermarkSrc"
  />
  @if (brand.id === 'anymatch') {
    <img
      [alt]="brand.name"
      [src]="(isDark$ | async) ? brand.logo.white : brand.logo.colour"
      class="bottom-right brand-logo"
      data-testid="powered-by-logo"
    />
  } @else {
    <p class="bottom-right on-surface-medium">Powered by {{ brand.name }}</p>
  }
</div>
